import CoreUI from '@coreui/vue'
import { CChart } from '@coreui/vue-chartjs'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(CoreUI)
  nuxtApp.vueApp.component('CChart', CChart)
})
